var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramFinancialPlanning40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FinancialPlanning40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "FinancialPlanning64-Copy-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(6.719262, 9.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5961001,19.616956 C13.5186731,19.61419 15.5510002,15.9209524 15.4137757,11.7579613 C15.3051845,8.46362298 13.5045197,5.01976948 10.0117812,1.4264009 C6.59982063,4.91309998 4.89224974,8.33777322 4.88906489,11.7004206 C4.8850669,15.9300348 8.28371642,19.6191427 10.5961001,19.616956 Z",
    id: "Focus",
    fill: "#FFCC00",
    fillRule: "nonzero",
    transform: "translate(10.154696, 10.521678) rotate(-45.000000) translate(-10.154696, -10.521678) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7806374,18 C18.9298155,18 21.2522216,14.3174337 21.2805368,10.2056996 C21.3028414,6.96679687 19.4695416,3.56489702 15.7806374,0 C12.1140377,3.50291614 10.2807379,6.91200704 10.2807379,10.2272727 C10.2807379,14.3972891 13.2889603,18 15.7806374,18 Z",
    id: "Oval-10",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.2807379,
    y1: 12,
    x2: 15.2807379,
    y2: 23,
    id: "Line-Copy",
    strokeLinecap: "square"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramFinancialPlanning40);
export default __webpack_public_path__ + "static/media/pictogramFinancialPlanning40.35dc4d64d21922a584920d13d42e9d20.svg";
export { ForwardRef as ReactComponent };